import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { BrandModal, BrandModalBody, BrandModalFooter, BrandModalHeader } from '../ui/BrandModal';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  loading = false,
}) => {
  return (
    <BrandModal open={isOpen} onClose={onClose} maxWidthClass="max-w-md">
      <BrandModalHeader title={title} onClose={onClose} />
      <BrandModalBody>
        <div className="flex gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-100">
            <ExclamationTriangleIcon className="h-6 w-6 text-rose-600" aria-hidden="true" />
          </div>
          <p className="text-sm text-slate-600">{message}</p>
        </div>
      </BrandModalBody>
      <BrandModalFooter>
        <button type="button" onClick={onClose} disabled={loading} className="btn btn-secondary text-sm">
          {cancelText}
        </button>
        <button type="button" onClick={onConfirm} disabled={loading} className="btn btn-danger text-sm">
          {loading ? 'Deleting...' : confirmText}
        </button>
      </BrandModalFooter>
    </BrandModal>
  );
};

export default DeleteConfirmModal;
